const orderModal = document.querySelector('.order-modal');
const orderModalMain = document.querySelector('.order-modal--main');

const closeOrderModal = () => {
  orderModal.classList.remove('is-active');
  document.body.classList.remove('body-locked');
  document.removeEventListener('keydown', handleEscapeKey);
};

const handleEscapeKey = (e) => {
  if (e.key === 'Escape') {
    closeOrderModal();
  }
};

const handleOverlayClick = (e) => {
  if (e.target === e.currentTarget) {
    closeOrderModal();
  }
};

// const handleButtonClose = () => {

// };

const initModal = () => {
  orderModal.addEventListener('click', handleOverlayClick);
  const closeButton = orderModal.querySelector('.order-modal__close');
  if (closeButton) {
    closeButton.addEventListener('click', closeOrderModal);
  }
};

const openOrderModal = () => {
  orderModal.classList.add('is-active');
  orderModalMain.classList.add('is-active');
  document.body.classList.add('body-locked');
  document.addEventListener('keydown', handleEscapeKey);
};

// initModal();

export { openOrderModal, closeOrderModal, initModal };